/** README
 *  这里管理的是项目级别的公共组件：
 *      1- 全局注册的公共组件
 *          提供一个默认的install方法，在main.js中进行安装注册
 * 
 * 
 *      2- 分模块管理，不同场景下，可能会使用到的公共组件
 * 
 * 
 * 
 *  注意事项：
 * 
 */


// ======VVVVVV====== [引入全局组件对应的源文件] ======VVVVVV======
import DragZoomContainer from './DragZoomContainer.vue'
import Dialog from './global/Dialog/index.vue'


function install(app) {
  app.component('drag-zoom-container', DragZoomContainer);
  app.component("Dialog", Dialog);
}


export default { install };

